const SUPPORT_EMAIL = 'support@gps-maap.org';

function HelpPanel() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Help</h2>
      </div>

      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="bg-gray-50 border-b border-gray-200 px-5 py-3">
          <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Contact Support</h3>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-gray-900">
            For help with your user account, your email address, or your MFA settings, email{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-blue-600 hover:underline">
              {SUPPORT_EMAIL}
            </a>
            .
          </p>
          <p className="text-sm text-gray-500">
            Include your MAAP account number, username, and phone number, along with a short
            description of the problem.
          </p>
        </div>
      </div>
    </div>
  );
}

export default HelpPanel;
